import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal as ModalAntd, Row } from 'antd'

import { FullRequestHotel, Request } from 'src/types'

import {
  resetSaveFullRequest,
  saveFullRequest
} from 'src/core/store/ducks/requests/actions'
import { ApplicationState } from 'src/store'
import { Button, Modal } from 'src/components/Ant'
import { HotelFormFilter } from 'src/components/molecules'
import { resetAir } from 'src/core/store/ducks/air/actions'
import { resetHotels } from 'src/core/store/ducks/hotels/actions'
import { resetVehicles } from 'src/core/store/ducks/vehicles/actions'
import { useT } from 'src/core/hooks/use-translation'

import SearchCardForm from '../search-card/form'
import SearchResultCardList from '../search-result-card/list'

type Props = {
  // itemEdit?: RequestItinerary
  request: Request
  toggle(): void
  visible: boolean
  approvals?: boolean
}

function ModalForm({
  // itemEdit,
  approvals,
  request,
  toggle,
  visible
}: Props): JSX.Element {
  const dispatch = useDispatch()
  const { requests, hotels } = useSelector((state: ApplicationState) => ({
    requests: state.requests,
    hotels: state.hotels
  }))

  const [modalFiltersVisible, setModalFiltersVisible] = useState(false)
  const [saving, setSaving] = useState<boolean>(false)
  const [selectedHotels, setSelectedHotels] = useState<FullRequestHotel[]>([])
  const { t } = useT()

  useEffect(() => {
    if (requests.saveFullRequestLoading !== saving && approvals && visible) {
      setSaving(requests.saveFullRequestLoading)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requests.saveFullRequestLoading])

  useEffect(() => {
    if (visible) {
      setSelectedHotels([])
      dispatch(resetAir())
      dispatch(resetHotels())
      dispatch(resetVehicles())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible])

  return (
    <Modal
      // cancelButtonProps={{ disabled: saving }}
      closable={!saving}
      forceRender
      maskClosable={!saving}
      title="web.services.hotels.form.title"
      onCancel={() => {
        toggle()
        dispatch(resetSaveFullRequest())
      }}
      visible={visible}
      width={820}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            toggle()
            dispatch(resetSaveFullRequest())
          }}
          size="default"
          title="common.actions.cancel"
          type="default"
        />
      ]}
    >
      <SearchCardForm request={request} />
      {!!Object.keys(hotels.searches).length && (
        <Row justify="end" type="flex">
          <Button
            type="dashed"
            icon="search"
            title="web.services.hotels.filters.title"
            onClick={() => setModalFiltersVisible(true)}
          />
        </Row>
      )}
      <SearchResultCardList
        modalLoading={requests.saveFullRequestLoading}
        onSubmit={fullRequestHotel => {
          ModalAntd.confirm({
            cancelText: t('common.actions.cancel'),
            content: t('web.services.alert-send-to-approval'),
            okText: t('common.actions.yes'),
            title: t('common.are-you-sure'),
            onCancel() {},
            onOk() {
              dispatch(
                saveFullRequest({
                  ...request,
                  full_request_hotel: fullRequestHotel
                })
              )
              setSelectedHotels([])
            }
          })
        }}
        request={request}
        selectedHotels={selectedHotels}
        setSelectedHotels={setSelectedHotels}
      />
      <Modal
        // cancelButtonProps={{ disabled: saving }}
        closable={!saving}
        forceRender
        maskClosable={!saving}
        title="web.services.hotels.filters.title"
        onCancel={() => {
          setModalFiltersVisible(false)
          setSelectedHotels([])
        }}
        visible={modalFiltersVisible}
        width={320}
        footer={[
          <Button
            key="continue"
            onClick={() => {
              setModalFiltersVisible(false)
              setSelectedHotels([])
            }}
            size="default"
            title="common.actions.continue"
            type="primary"
          />
        ]}
      >
        <HotelFormFilter />
      </Modal>
    </Modal>
  )
}

export default ModalForm
